import FormCard from '../../inputFormComponents/FormCard'
import FormRow from '../../inputFormComponents/FormRow'
import { SelectInput, TextInput, email, required, useTranslate } from 'react-admin'
import { Gender } from '../../GeneratedClients/FreeBillApi'
import DescriptionUserContact from './descriptions/DescriptionUserContact'

const UserContactCard = () => {
  const translate = useTranslate()

  return (
    <FormCard title={translate('resources.contact.name')} 
      description={<DescriptionUserContact />}
      rows={[
        <FormRow fields={[
          <SelectInput fullWidth helperText={false} source="contact.gender" validate={required()} label="resources.contact.gender" choices={[
            {id: Gender.Male, name: translate(`resources.contact.${Gender.Male.toLowerCase()}`)}, 
            {id: Gender.Female, name: translate(`resources.contact.${Gender.Female.toLowerCase()}`)}
          ]} />,
          <TextInput sx={{ml:2}} fullWidth helperText={false} source="contact.lastName" validate={required()} label="resources.contact.lastName" />,
          <TextInput sx={{ml:2}} fullWidth helperText={false} source="contact.firstName" label="resources.contact.firstName" />
        ]}/>,
        <FormRow fields={[
          <TextInput fullWidth helperText={false} source="contact.email" validate={[required(), email()]} label="resources.contact.email" />,
          <TextInput sx={{ml:2}} fullWidth helperText={false} source="contact.phone" label="resources.contact.phone" />
        ]}/>,
      ]}
    />
  )
}

export default UserContactCard